import { createContext } from 'react';
import defaultConfig from '../../internal/config/defaultConfig';
export default /*#__PURE__*/ createContext(defaultConfig);

//# sourceMappingURL=ObservabilityConfigContext.js.map